import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSkip: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"skip, next"} maskId="square-filled-radius-0-stroke-1-IconSkip"><path d="M19 4H18V20H19V4Z" fill="currentColor"/><path d="M5 4.07608V19.9239L17.1284 12L5 4.07608Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconSkip;
